<template>
  <div
    class="aha-avatar"
    :class="[`aha-avatar--${size}`]"
    :style="{width: `${width}px`, height: `${height}px`}"
  >
    <div v-if="image" class="aha-avatar__image">
      <img :src="image">
    </div>
    <div v-else class="aha-avatar__image" :style="{backgroundColor: avatarColor}">
      {{ showingName | textAvatar }}
    </div>
  </div>
</template>

<script>
import colorUtil from '../../../utils/colors'

export default {
  props: {
    size: {
      type: String,
      default: 'md',
    },
    width: {
      type: Number,
      default: null,
    },
    height: {
      type: Number,
      default: null,
    },
    image: {
      type: String,
      default: null,
    },
    name: {
      type: String,
      default: 'Unknown',
    },
    id: {
      type: Number,
      default: null,
    },
  },

  computed: {
    showingName() {
      return this.name || 'Unknown'
    },
    avatarColor() {
      const id = this.id ? this.id : this.showingName.charCodeAt(0)
      return colorUtil.getRandomColor(id)
    },
  },

}
</script>

<style lang="scss" scoped>
.aha-avatar {
  @apply flex flex-row items-center rounded-full overflow-hidden flex-shrink-0;
}
.aha-avatar--sm {
  width: 20px;
  height: 20px;
}
.aha-avatar--md {
  width: 28px;
  height: 28px;
}
.aha-avatar--lg {
  width: 36px;
  height: 36px;
}
.aha-avatar--xl {
  width: 42px;
  height: 42px;
}

.aha-avatar__image {
  @apply flex items-center justify-center w-full h-full;
  @apply text-base-0 uppercase;
  img {
    @apply rounded-full;
  }

}
</style>>
